import { QuestionInputTypes } from '@infl-ts/ui-advocate-components';
import { nullable } from '@infl-ts/util-io-ts';
import { Activity, Challenge, ChallengeCard } from '@infl-ts/util-use-challenge-player';
import * as t from 'io-ts';
var SocialAccountBase = t.type({
  id: t.string,
  connected: t["boolean"],
  authUrl: t.string
});
var TwitterAccount = t.intersection([t.type({
  __typename: t.literal('Twitter')
}), SocialAccountBase]);
var SocialAccount = t.union([t.intersection([t.type({
  __typename: t.literal('Facebook')
}), SocialAccountBase]), t.intersection([t.type({
  __typename: t.literal('Linkedin')
}), SocialAccountBase]), TwitterAccount, t.intersection([t.type({
  __typename: t.literal('Apple')
}), SocialAccountBase]), t.intersection([t.type({
  __typename: t.literal('OAuth2')
}), SocialAccountBase]), t.intersection([t.type({
  __typename: t.literal('Google')
}), SocialAccountBase])], 'SocialAccount');
var Profile = t.type({
  id: t.string,
  name: t.string,
  avatarUrl: nullable(t.string),
  currentPoints: t.number,
  company: nullable(t.string),
  title: nullable(t.string),
  isAdmin: t["boolean"],
  isClone: t["boolean"],
  socialAccounts: t.array(SocialAccount)
});
export var ChallengeInfoQuery = t.type({
  challenge: Challenge,
  profile: Profile
});
export var ChallengeInfoQueryVariables = t.type({
  challengeId: t.string
});
var InProgressChallengeResult = t.type({
  __typename: t.literal('InProgressChallengeResult'),
  accruedPoints: t.number,
  activity: Activity,
  notificationMessages: nullable(t.array(t.string))
});
export var ChallengeList = t.array(ChallengeCard);
var CompleteChallengeResult = t.type({
  __typename: t.literal('CompleteChallengeResult'),
  accruedPoints: t.number,
  activity: Activity,
  notificationMessages: nullable(t.array(t.string)),
  suggestedChallenges: nullable(ChallengeList),
  unlockedChallenges: nullable(ChallengeList)
});
export var CompleteStageMutationOutput = t.type({
  completeStage: t.union([InProgressChallengeResult, CompleteChallengeResult, t.type({
    __typename: t.literal('CompleteStageErrors'),
    errors: t.array(t.type({
      message: t.string,
      __typename: t.string
    }))
  })])
});
export var CompleteStageInputBase = t.intersection([t.type({
  stageID: t.string
}), t.partial({
  activityID: t.string
})]);
var ImageInput = t.intersection([t.type({
  url: t.string
}), t.partial({
  filestack: nullable(t.type({
    handle: t.string
  }))
})]);
var Response = QuestionInputTypes.Response;
var CompleteStageInput = t.partial({
  onlineActionInput: CompleteStageInputBase,
  npsInput: t.intersection([CompleteStageInputBase, t.partial({
    response: Response
  })]),
  questionsInput: t.intersection([CompleteStageInputBase, t.partial({
    responses: t.array(Response)
  })]),
  g2ReviewInput: t.intersection([CompleteStageInputBase, t.partial({
    response: Response
  })]),
  checkInInput: t.intersection([CompleteStageInputBase, t.partial({
    latitude: t.string,
    longitude: t.string
  })]),
  reviewInput: t.intersection([CompleteStageInputBase, t.partial({
    response: Response
  })]),
  videoUploadInput: t.intersection([CompleteStageInputBase, t.type({
    file: ImageInput
  })]),
  imageUploadInput: t.intersection([CompleteStageInputBase, t.type({
    file: ImageInput
  }), t.partial({
    response: Response
  })]),
  fileUploadInput: t.intersection([CompleteStageInputBase, t.type({
    file: ImageInput
  })]),
  shareLinkInput: CompleteStageInputBase,
  discussionReplyInput: CompleteStageInputBase,
  quizInput: t.intersection([CompleteStageInputBase, t.partial({
    responses: t.array(Response)
  })]),
  twitterPostInput: t.intersection([CompleteStageInputBase, t.type({
    tweet: t.string
  })]),
  apiIntegrationInput: CompleteStageInputBase,
  twitterFollowInput: CompleteStageInputBase,
  influitiveGroupJoinInput: CompleteStageInputBase,
  advocateAcceptanceInput: CompleteStageInputBase,
  updateProfileInput: t.intersection([CompleteStageInputBase, t.type({
    file: nullable(ImageInput),
    title: nullable(t.string),
    company: nullable(t.string)
  })])
}, 'CompleteStageInput');
export var CompleteStageMutationInput = t.type({
  input: t.intersection([t.partial({
    platform: t.string
  }), CompleteStageInput])
});
export var UpdateChallengeAsOpenedOutput = t.type({
  id: t.string,
  unseen: t["boolean"]
});
export var UpdateChallengeAsOpenedInput = t.type({
  id: t.string
});